export const AppConstants = {
  ASSET_QUALITY: 70,
  sort: {
    updated: '-date_updated',
    created: '-date_created'
  },
  FEEDBACK_SESSION: 'feedback_session',
  SKIP_PWA_INSTALLER: 'skip_pwa_installer',
  PWA_INSTALLED: 'pwa_installed',
  RECENT_SEARCHES: 'recent_searches',
  STORAGE_KEY: 'pis_wuestenrot_'
};
